import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { notificationInit } from '../../modules/notifications/actions';
import {
	getIcepacksFilledRequest,
	getIcepacksFillersRequest,
	getIcepacksStatesRequest,
	getModesDictionaryRequest,
} from '../../api/requests';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { DISMISS_TIME } from '../../api/constants';
import {
	GET_ICEPACKS_FILLED,
	setIcepacksFilledAction,
	setIcepacksFillersAction,
	setIcepacksStatesAction,
	setIsIcepacksFilledLoadingAction,
	setIsIcepacksFillersLoadingAction,
	setIsIcepacksStatesLoadingAction,
	setPaginationAction,
	setIsModesLoadingAction,
	setModesAction,
	GET_ICEPACKS_FILLERS,
	GET_ICEPACKS_STATES,
	GET_MODES,
} from './actions';
import { errorHandler } from '../../api/utils';

export function* getIcepacksFilledSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsIcepacksFilledLoadingAction(true));
		}
		const { data, meta, message, toast } = yield call(getIcepacksFilledRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(
				setIcepacksFilledAction(
					data?.map(icepack => ({
						...icepack,
						link: `?${searchQuery ? `${searchQuery}&` : ''}modal=icepack_filled&id=${icepack.id}`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsIcepacksFilledLoadingAction(false));
	}
}

export function* getIcepacksFillersSaga() {
	try {
		yield put(setIsIcepacksFillersLoadingAction(true));

		const { data, message, toast } = yield call(getIcepacksFillersRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setIcepacksFillersAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsIcepacksFillersLoadingAction(false));
	}
}

export function* getIcepacksStatesSaga() {
	try {
		yield put(setIsIcepacksStatesLoadingAction(true));

		const { data, message, toast } = yield call(getIcepacksStatesRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setIcepacksStatesAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsIcepacksStatesLoadingAction(false));
	}
}

export function* getModesSaga() {
	try {
		yield put(setIsModesLoadingAction(true));

		const { data, message, toast } = yield call(getModesDictionaryRequest, '?receive=all');

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			yield put(setModesAction(data));
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsModesLoadingAction(false));
	}
}

export default function* icepacksContainerSaga() {
	yield takeEvery(GET_ICEPACKS_FILLED, getIcepacksFilledSaga);
	yield takeEvery(GET_ICEPACKS_FILLERS, getIcepacksFillersSaga);
	yield takeEvery(GET_ICEPACKS_STATES, getIcepacksStatesSaga);
	yield takeEvery(GET_MODES, getModesSaga);
}
